// extracted by mini-css-extract-plugin
module.exports = {"fadeInSection":"ejYUwA","isVisible":"t1Z_7C"};